import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.css']
})
export class ConfirmationPopupComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<ConfirmationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private location: Location,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  close() {
    if (this.router.url.includes('/dashboard/contactus')) {
      this.dialogRef.close();
    } else {
      this.dialogRef.close();
      this.router.navigate([`/myprofile`]);
    }
  }

}
